import { X } from "lucide-react";


const CRYPTO_LIST = [
  {
    id: "btc",
    name: "Bitcoin",
    symbol: "BTC",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1696501400",
  },
  {
    id: "eth",
    name: "Ethereum",
    symbol: "ETH",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1696501410",
  },
  {
    id: "usdt",
    name: "Tether",
    symbol: "USDT",
    logo: "https://assets.coingecko.com/coins/images/325/small/Tether.png?1696501661",
  },
  {
    id: "bnb",
    name: "BNB",
    symbol: "BNB",
    logo: "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png?1696501970",
  },
  {
    id: "sol",
    name: "Solana",
    symbol: "SOL",
    logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png?1696504756",
  },
  {
    id: "xrp",
    name: "XRP",
    symbol: "XRP",
    logo: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1696501442",
  },
];

export default function SendCryptoListModal({ isOpen, onClose, onSelectCrypto }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-primary">Send Crypto</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition"
            aria-label="Close modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-3">
          {CRYPTO_LIST.map((crypto) => (
            <button
              key={crypto.id}
              onClick={() => {
                onSelectCrypto(crypto);
                onClose();
              }}
              className="w-full flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:border-primary hover:bg-primary/5 transition"
              aria-label={`Select ${crypto.name}`}
            >
              <img
                src={crypto.logo}
                alt={`${crypto.name} logo`}
                className="w-10 h-10 object-contain"
                loading="lazy"
              />
              <div className="text-left">
                <p className="font-semibold text-gray-900">{crypto.name}</p>
                <p className="text-sm text-gray-500">{crypto.symbol}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}